import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, Navigate } from "react-router-dom";
import DataFreteTableCopy from "./components/data-frete-table-action";
import AddIcon from '@mui/icons-material/Add';
import { Button } from 'antd';
import './frete-list.css';
import NewMiniDrawer from "../../components/navMenu/menu-nav";
// import TableFreightList from "../../components/data-frete-table/dataFreightTableAG";
require("firebase/auth");

function FreightListCopy() {
  const [carregando, setCarregando] = useState(0);
  const [cleanFilters, setCleanFilters] = useState(false);
  const [openFilters, setOpenFilters] = useState(false);
  const userLogado = useSelector((state) => state.usuarioLogado);
  const user = useSelector((state) => state.user);

  useEffect(() => {

    if (userLogado > 0) {
      return;
    }
    else {
      <Navigate to='/login' />
    }

  }, [carregando]);

  return (
    <>
      {useSelector((state) => state.usuarioLogado) > 0 ? (
        <NewMiniDrawer
          divOpen={
            <div className="freight-content">
              <div className="container" style={{ marginRight: "unset", marginLeft: "unset" }}>
                <div className="row">
                  <div className="col-5">
                    <h3>Listagem de Frete</h3>
                  </div>
                  <div className="col-3"></div>
                  <div className="col-1">
                    <div className="col-md-11 control-label">
                      {
                        user?.permissoes?.freight?.isCreate || user?.permissoes?.frete?.cadastrar ? (
                        <Link to={"/freightCopy"}>
                          <Button id="ButtonHover" type="primary"   class="btn btn-primary btn-vertical" icon={<AddIcon  />}>
                            Novo
                          </Button>
                        </Link>
                        )
                        :
                        (
                          ""
                        )
                      }
                    </div>
                  </div>
                  <div className="col-1">
                    <Button
                      type="primary"
                      onClick={() => setCleanFilters(!cleanFilters)}
                      className="btn-limpar-filtros"
                    >
                      Limpar Filtros
                    </Button>
                  </div>
                  <div 
                    style={{ marginLeft: "1.5%" }} 
                    className="col-1"
                    onClick={() => setOpenFilters(!openFilters)}
                  >
                    <Button >
                      Filtros Salvos
                    </Button>
                  </div>
                </div>
              <br></br>
              <br></br>
              </div>
              {carregando ? (
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              ) : (
                <DataFreteTableCopy cleanFilter={cleanFilters} openFilter={openFilters} onCleanFilterHandled={() => setCleanFilters(false)} onOpenFilterHandled={() => setOpenFilters(false)} />
                // <TableFreightList />
              )}
            </div>
          }
        />
      ) : (
        <Navigate to="/login" />
      )}
    </>
  );
}

export default FreightListCopy;
